import React from 'react'
import { Flex, Link as ExternalLink } from 'rebass/styled-components'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import NavItem from './NavItem'
import SubNav from './Secondary'

const Nav = styled(Flex)`
    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        display: none;
    }
`

const NavGroup = styled(Flex)`
    width: calc(50% - 33px);
`

const baseStyles = css`
    color: ${(props) => props.theme.colors.black};
    display: block;
    height: 100%;
    line-height: 56px;
    padding-left: ${(props) => props.theme.space.sm};
    padding-right: ${(props) => props.theme.space.sm};
    position: relative;
    text-decoration: none;

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding-left: ${(props) => props.theme.space.xs};
        padding-right: ${(props) => props.theme.space.xs};
    }

    &:before {
        display: block;
        content: attr(title);
        font-weight: ${(props) => props.theme.fontWeights.bold};
        height: 0;
        overflow: hidden;
        visibility: hidden;
    }
    &:after {
        border-right: 1px solid ${(props) => props.theme.colors.black};
        position: absolute;
        display: block;
        content: '';
        height: 18px;
        top: calc(50% - 9px);
        right: -1px;
    }
`

const NavAnchor = styled(Link)`
    ${baseStyles}
`

const NavExternalAnchor = styled(ExternalLink)`
    ${baseStyles}
`

const PrimaryDesktop = () => {
    return (
        <Nav
            alignItems='flex-start'
            as='nav'
            fontSize={['sm', 'sm', 'sm', 'sm', 'md', 'md', 'md']}
            itemType='http://schema.org/SiteNavigationElement'
            itemScope='itemscope'
            justifyContent='space-between'
            ml={['sm', 'sm', 'sm', 'sm', 'sm', 'auto', 'auto']}
            mr={['sm', 'sm', 'sm', 'sm', 'sm', 'auto', 'auto']}
            role='navigation'
            variant='container'
            sx={{
                letterSpacing: '0.6px',
                position: 'relative',
                textAlign: 'center',
                whiteSpace: 'nowrap',
            }}
        >
            <NavGroup
                alignItems='center'
                alignSelf='center'
                as='ul'
                bg='white'
                height='56px'
                pl={['xs', 'xs', 'xs', 'xs', 'xs', 'sm', 'sm']}
                pr={['xs', 'xs', 'xs', 'xs', 'xs', 'sm', 'sm']}
                sx={{
                    listStyle: 'none',
                    position: 'relative',
                }}
            >
                <NavItem>
                    <NavAnchor
                        aria-label='Link to about page'
                        title='About'
                        activeClassName='active'
                        partiallyActive
                        itemProp='name'
                        to='/about'
                    >
                        About
                    </NavAnchor>
                    <SubNav>
                        <NavItem>
                            <NavAnchor
                                aria-label='Link to company page'
                                title='The Company'
                                activeClassName='active'
                                itemProp='name'
                                to='/about'
                            >
                                The Company
                            </NavAnchor>
                        </NavItem>
                        <NavItem>
                            <NavAnchor
                                aria-label='Link to services page'
                                title='Our Services'
                                activeClassName='active'
                                itemProp='name'
                                to='/about/services'
                            >
                                Our Services
                            </NavAnchor>
                        </NavItem>
                        {/* <NavItem>
                            <NavAnchor aria-label="Link to gallery page" title="Galleries" activeClassName="active" itemProp="name" to="/galleries" >
                                Gallery
                            </NavAnchor>
                        </NavItem> */}
                        <NavItem>
                            <NavAnchor
                                aria-label='Link to testimonials page'
                                title='Testimonials'
                                activeClassName='active'
                                itemProp='name'
                                to='/about/testimonials'
                            >
                                Testimonials
                            </NavAnchor>
                        </NavItem>
                    </SubNav>
                </NavItem>
                <NavItem>
                    <NavAnchor
                        aria-label='Link to cars page'
                        title='Cars'
                        activeClassName='active'
                        partiallyActive
                        itemProp='name'
                        to='/cars-for-sale/'
                    >
                        Cars
                    </NavAnchor>
                    <SubNav>
                        <NavItem>
                            <NavAnchor
                                aria-label='Link to cars offered for sale page'
                                title='Cars for sale'
                                activeClassName='active'
                                itemProp='name'
                                to='/cars-for-sale/available'
                            >
                                Offered for Sale
                            </NavAnchor>
                        </NavItem>
                        <NavItem>
                            <NavAnchor
                                aria-label='Link to previously handled cars page'
                                title='Previously Handled'
                                activeClassName='active'
                                itemProp='name'
                                to='/cars-for-sale/sold'
                            >
                                Previously Handled
                            </NavAnchor>
                        </NavItem>
                    </SubNav>
                </NavItem>
                <NavItem>
                    <NavAnchor
                        aria-label='Link to services page'
                        title='Restorations'
                        activeClassName='active'
                        itemProp='name'
                        to='/restorations'
                    >
                        Restorations
                    </NavAnchor>
                </NavItem>
            </NavGroup>
            <NavGroup
                alignItems='center'
                alignSelf='center'
                as='ul'
                bg='white'
                justifyContent='flex-end'
                height='56px'
                pl={['xs', 'xs', 'xs', 'xs', 'xs', 'sm', 'sm']}
                pr={['xs', 'xs', 'xs', 'xs', 'xs', 'sm', 'sm']}
                sx={{
                    listStyle: 'none',
                    position: 'relative',
                }}
            >
                <NavItem>
                    <NavAnchor
                        aria-label='Link to Films page'
                        title='Films'
                        activeClassName='active'
                        itemProp='name'
                        to='/films'
                    >
                        Films
                    </NavAnchor>
                </NavItem>
                <NavItem>
                    <NavAnchor
                        aria-label='Link to about page'
                        title='Publications'
                        activeClassName='active'
                        itemProp='name'
                        to='/publications'
                    >
                        Publications
                    </NavAnchor>
                </NavItem>
                <NavItem>
                    <NavExternalAnchor
                        href='#'
                        title='K-Ops'
                        sx={{ pointerEvents: 'none' }}
                    >
                        K-Ops
                    </NavExternalAnchor>
                    <SubNav align='right'>
                        <NavItem>
                            <NavExternalAnchor
                                target='_blank'
                                aria-label='Link to Top Motors Salvioli'
                                title='Top Motors Salvioli'
                                href='https://topmotorsalvioli.com/'
                            >
                                Top Motors Salvioli
                            </NavExternalAnchor>
                        </NavItem>
                        {/* <NavItem>
                            <NavExternalAnchor
                                target='_blank'
                                aria-label='Link to Miurabook.com'
                                title='Miura Book'
                                href='https://miurabook.com/shop/the-lamborghini-miura-book-register-only/'
                            >
                                Miura Book
                            </NavExternalAnchor>
                        </NavItem> */}
                        <NavItem>
                            <NavExternalAnchor
                                target='_blank'
                                aria-label='Link to K500.com'
                                title='K500'
                                href='https://k500.com/'
                            >
                                K500
                            </NavExternalAnchor>
                        </NavItem>
                        <NavItem>
                            <NavExternalAnchor
                                target='_blank'
                                aria-label='Link to miuraregister.com'
                                title='Miura Register'
                                href='https://miuraregister.com/'
                            >
                                Online Miura Register
                            </NavExternalAnchor>
                        </NavItem>
                    </SubNav>
                </NavItem>
                <NavItem>
                    <NavAnchor
                        aria-label='Link to contact page'
                        title='Contact'
                        activeClassName='active'
                        partiallyActive
                        itemProp='name'
                        to='/contact'
                    >
                        Contact
                    </NavAnchor>
                    <SubNav align='right'>
                        <NavItem>
                            <NavAnchor
                                aria-label='Link to consignment page'
                                title='Consignment'
                                activeClassName='active'
                                itemProp='name'
                                to='/contact/consignment'
                            >
                                Consignment
                            </NavAnchor>
                        </NavItem>
                    </SubNav>
                </NavItem>
            </NavGroup>
        </Nav>
    )
}

function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps)(PrimaryDesktop)
